import api from "./api";
import log from "loglevel";
import { GetterTree, Module } from "vuex";
import { ActionContext } from "vuex";
import { RootState } from "@/store";
import { apiResponse } from "@/service/Api/Api";
import { postAdministratorInvitationUrlResponse } from "./api";

type InviteAdministratorContext = ActionContext<
  InviteAdministratorState,
  RootState
>;

export interface InviteAdministratorState {
  administratorName: string;
  administratorInvitationUrl: string;
  urlExpiresTimestamp: string;
  volumeLicenseId: string;
}

export default {
  namespaced: true,
  state: {
    administratorName: "",
    administratorInvitationUrl: "",
    urlExpiresTimestamp: "",
    volumeLicenseId: "",
  } as InviteAdministratorState,

  getters: {
    getAdministratorName: (state) => {
      return state.administratorName;
    },
    getAdministratorInvitationUrl: (state) => {
      return state.administratorInvitationUrl;
    },
    getUrlExpiresTimestamp: (state) => {
      return state.urlExpiresTimestamp;
    },
  } as GetterTree<InviteAdministratorState, RootState>,

  actions: {
    async postAdministratorInvitationUrl(
      context: InviteAdministratorContext,
      params: any
    ): Promise<postAdministratorInvitationUrlResponse & apiResponse> {
      try {
        const res = await api.postAdministratorInvitationUrl(
          params,
          context.state.volumeLicenseId
        );

        context.commit("updatePostAdministratorInvitationUrlRes", res);
        context.commit("updateAdministratorName", params.administrator_name);
        return res;
      } catch (error) {
        log.error(error);
        throw error;
      }
    },
  },

  mutations: {
    updateVolumeLicensesId(
      state: InviteAdministratorState,
      payload: string
    ): void {
      state.volumeLicenseId = payload;
    },
    updateAdministratorName(
      state: InviteAdministratorState,
      payload: string
    ): void {
      state.administratorName = payload;
    },
    updatePostAdministratorInvitationUrlRes(
      state: InviteAdministratorState,
      payload: any
    ): void {
      state.administratorInvitationUrl = payload.administrator_invitation_url;
      state.urlExpiresTimestamp = payload.url_expires_timestamp;
    },
  },
} as Module<InviteAdministratorState, RootState>;
